import React from 'react';

const HeaderTitle = ({ floorName }) => (
    <h3>Редактор этажа: {floorName}</h3>
);

export default HeaderTitle;
